import { gql } from '@apollo/client';
import {
    BASIC_FILE_FIELDS_FRAGMENT,
    BASIC_FILE_TYPE_FIELDS_FRAGMENT,
    MACHINE_CALIBRATION_FRAGMENT,
    EQUIPMENT_CALIBRATION_FRAGMENT
} from './file';

export const FOLDERS_FRAGMENT = gql`
    fragment FolderFields on Folder {
        FolderId
        Name
        Name_EN
        Name_SV
        Name_NO
        ParentId
        FolderTypeId
        Files {
            ...BasicFileFields
            FileType {
                ...BasicFileTypeFields
            }
            MachineCalibration {
                ...MachineCalibrationFields
            }
            EquipmentCalibration {
                ...EquipmentCalibrationFields
            }
        }
        SubFolders {
            FolderId
            Name
            Name_EN
            Name_SV
            Name_NO
            ParentId
            ParentFolder {
                FolderId
                Name
                Name_EN
                Name_SV
                Name_NO
            }
            Files {
                ...BasicFileFields
                FileType {
                    ...BasicFileTypeFields
                }
                MachineCalibration {
                    ...MachineCalibrationFields
                }
                EquipmentCalibration {
                    ...EquipmentCalibrationFields
                }
            }
            SubFolders {
                FolderId
                Name
                Name_EN
                Name_SV
                Name_NO
                ParentId
                ParentFolder {
                    FolderId
                    Name
                    Name_EN
                    Name_SV
                    Name_NO
                }
                Files {
                    ...BasicFileFields
                    FileType {
                        ...BasicFileTypeFields
                    }
                    MachineCalibration {
                        ...MachineCalibrationFields
                    }
                    EquipmentCalibration {
                        ...EquipmentCalibrationFields
                    }
                }
                SubFolders {
                    FolderId
                    Name
                    Name_EN
                    Name_SV
                    Name_NO
                    ParentId
                    ParentFolder {
                        FolderId
                        Name
                        Name_EN
                        Name_SV
                        Name_NO
                    }
                    Files {
                        ...BasicFileFields
                        FileType {
                            ...BasicFileTypeFields
                        }
                        MachineCalibration {
                            ...MachineCalibrationFields
                        }
                        EquipmentCalibration {
                            ...EquipmentCalibrationFields
                        }
                    }
                }
            }
        }
    }
    ${BASIC_FILE_FIELDS_FRAGMENT}
    ${BASIC_FILE_TYPE_FIELDS_FRAGMENT}
    ${MACHINE_CALIBRATION_FRAGMENT}
    ${EQUIPMENT_CALIBRATION_FRAGMENT}
`;

export const DELETE_FOLDERS_FRAGMENT = gql`
    fragment DeleteFoldersOutputFields on DeleteFoldersOutputType {
        Folders {
            ...FolderFields
        }
        FolderType
    }
    ${FOLDERS_FRAGMENT}
`;

export const FOLDER_TEMPLATES_FRAGMENT = gql`
    fragment FolderTemplateFields on FolderTemplatesReturnType {
        FolderTemplateId
        Name
        Name_EN
        Name_SV
        Name_NO
        FolderStructure {
            TranslationEntry {
                FI
                EN
                SV
                NO
            }
            OrderNumber
        }
    }
`;
